import { render, staticRenderFns } from "./RoleLine.vue?vue&type=template&id=4ac442a4"
import script from "./RoleLine.vue?vue&type=script&lang=ts"
export * from "./RoleLine.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports